var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgNew = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9368 18.1263H2.30522V5.2631H9.67365V3.15784H2.30522C1.14732 3.15784 0.199951 4.10521 0.199951 5.2631V17.8947C0.199951 19.0526 1.14732 20 2.30522 20H14.9368C16.0947 20 17.0421 19.0526 17.0421 17.8947V10.5263H14.9368V18.1263Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.042 0H14.9367V3.1579H11.7788C11.7894 3.16842 11.7788 5.26316 11.7788 5.26316H14.9367V8.41054C14.9473 8.42106 17.042 8.41054 17.042 8.41054V5.26316H20.1999V3.1579H17.042V0ZM4.4104 7.36843H12.8315V9.4737H4.4104V7.36843ZM4.4104 10.5263V12.6316H12.8315V10.5263H9.67356H4.4104ZM4.4104 13.6842H12.8315V15.7895H4.4104V13.6842Z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNew, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/new.95ee04a2.svg";
export { ForwardRef as ReactComponent };